/* prettier ignore */
export const content = {
  'designer.branches.presence.warning':
    'Only one person can access a branch at a time',
  'designer.branches.merge.enabled': 'Merge this branch with your site',
  'designer.branches.merge.enabled.warning':
    'Merging this branch will replace the original page.',
  'designer.branches.merge.disabled.this-branch-merge-in-progress-text':
    'Merge in progress',
  'designer.branches.merge.disabled.branch-update-in-progress-text':
    'Update in progress',
  'designer.branches.delete.disabled.branch-update-in-progress-text':
    'Unavailable during branch update',
  'designer.branches.delete.disabled.branch-merge-in-progress-text':
    'Unavailable during branch merge',
  'designer.branches.merge.disabled.menu-label': 'Merging...',
  'designer.branches.update.disabled.menu-label': 'Updating...',
  'designer.branches.merge.disabled.design-control-text':
    'To merge this branch, you need full design control',
  'designer.branches.merge.disabled.role-permissions-text':
    "Your role doesn't have permission to merge branches",
  'designer.branches.merge.disabled.need-review-text':
    'This branch needs to be reviewed and approved before merging',
  'designer.branches.merge.disabled.review-pending-text':
    'This branch needs to be approved before merging',
  'designer.branches.merge.disabled.any-branch-merge-in-progress-text':
    "{{name}} is merging a branch. You can merge after it's done.",
  'designer.branches.merge.disabled.branch-publish-in-progress-text':
    'You can merge after this branch is done publishing.',
  'designer.branches.publish.in-progress.full-site':
    '{{name}} is publishing the full site.',
  'designer.branches.publish.in-progress.page':
    '{{name}} is publishing "{{pageName}}".',
  'designer.branches.publish.in-progress.branch':
    '{{name}} is publishing a branch of "{{pageName}}".',
  'designer.branches.publish.in-progress.release':
    '{{name}} is currently publishing',
  'designer.branches.publish.in-progress.generic': '{{name}} is publishing.',
  'designer.branches.create.disabled.restricted':
    "You can't create a branch for this page",
  'designer.branches.merge.disabled.restricted': "You can't merge this branch",
  'designer.branches.merge.redirect.title': 'Branch merging',
  'designer.branches.merge.redirect.description':
    'This branch is being merged by {{name}}. You will be redirected to the {{pageName}} page.',
  'designer.branches.merge.redirect.success': 'Branch merged by {{name}}',
  'designer.branches.redirect.continue': 'Continue',
  'designer.branches.delete.redirect.title': 'Branch deleted',
  'designer.branches.delete.redirect.description':
    'This branch has been deleted by {{name}}. You will be redirected to the {{pageName}} page.',
  'designer.branches.delete.redirect.success': 'Branch deleted by {{name}}',
};
